__turbopack_context__.v({
  "container": "FundraiserOrganizationInfo-module-scss-module__A0yktG__container",
  "logo": "FundraiserOrganizationInfo-module-scss-module__A0yktG__logo",
  "text": "FundraiserOrganizationInfo-module-scss-module__A0yktG__text",
});
